import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { authorizedRequest, HTTP_METHODS } from "utils/request";
import { getUserId } from "utils/userStorage";
import { AuthorizedRequestBuilder } from "utils/sagaBuilder";
import {
  CHANGE_PASSWORD_ACTION,
  CHANGE_PASSWORD_FAILED_ACTION,
  CHANGE_PASSWORD_SUCCESS_ACTION,
  CHANGE_PASSWORD_URL,
  CHANGE_USER_ACTION,
  CHANGE_USER_FAILED_ACTION,
  CHANGE_USER_SUCCESS_ACTION,
  GET_PRACTICE_MESSAGES,
  GET_USER_ACTION,
  GET_USER_FAILED_ACTION,
  GET_USER_SUCCESS_ACTION,
  LANGUAGE_ACTION,
  LANGUAGE_FAILED_ACTION,
  LANGUAGE_SUCCESS_ACTION,
  LANGUAGE_URL,
  USER_URL,
} from "./constants";
import {
  getPracticeMessagesError,
  getPracticeMessagesSuccess,
} from "./actions";
import { getPractice } from "../../utils/practiceStorage";

// Get the current user
const getUserSaga = new AuthorizedRequestBuilder(
  GET_USER_SUCCESS_ACTION,
  GET_USER_FAILED_ACTION,
)
  .url(() => `${USER_URL}/${getUserId()}`)
  .resultKey("user")
  .build();

// Change the current user.
const changeUserSaga = new AuthorizedRequestBuilder(
  CHANGE_USER_SUCCESS_ACTION,
  CHANGE_USER_FAILED_ACTION,
)
  .body(action => action.userData)
  .method(HTTP_METHODS.PUT)
  .callbackBuilder(action => action.callback)
  .url(USER_URL)
  .build();

const changePasswordSaga = new AuthorizedRequestBuilder(
  CHANGE_PASSWORD_SUCCESS_ACTION,
  CHANGE_PASSWORD_FAILED_ACTION,
)
  .body(({ oldPassword, newPassword }) => ({
    oldPassword,
    newPassword,
  }))
  .method(HTTP_METHODS.PUT)
  .url(CHANGE_PASSWORD_URL)
  .callbackBuilder(action => action.callback)
  .build();

const getLanguageSaga = new AuthorizedRequestBuilder(
  LANGUAGE_SUCCESS_ACTION,
  LANGUAGE_FAILED_ACTION,
)
  .resultKey("languages")
  .url(LANGUAGE_URL)
  .build();

function* getMessages({ limit, offset, filter }) {
  try {
    const practiceId = getPractice().id;

    const result = yield call(
      authorizedRequest,
      `/practices/${practiceId}/messages/pagination/filter?limit=${limit}&offset=${offset}`,
      {
        method: HTTP_METHODS.POST,
        body: { filter },
      },
    );

    yield put(
      getPracticeMessagesSuccess({
        messages: result.list,
        statusOpenCount: result.statusOpenCount,
      }),
    );
  } catch (err) {
    yield put(getPracticeMessagesError(err));
  }
}

// Individual exports for testing
export default function* userEditPageSaga() {
  // See example in containers/HomePage/saga.js
  yield takeEvery(CHANGE_PASSWORD_ACTION, changePasswordSaga);
  yield takeEvery(GET_USER_ACTION, getUserSaga);
  yield takeEvery(CHANGE_USER_ACTION, changeUserSaga);
  yield takeEvery(LANGUAGE_ACTION, getLanguageSaga);

  yield takeLatest(GET_PRACTICE_MESSAGES, getMessages);
}
